/* eslint-disable */
export default {
  account: 'Cuenta',
  contact: 'Contacto',
  lead: 'Prospecto',
  opportunity: 'Oportunidad',
  case: 'Caso',
  chooseEntity: 'Seleccionar tipo de entidad',
  create: 'Crear',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
